import React, { useEffect } from 'react';
import { Modal, Button, Text, Flex } from '@mantine/core';
import { DatePicker } from '@mantine/dates';

interface DateSelectionModalProps {
    opened: boolean;
    onClose: () => void;
    onSubmit: (date: Date) => void;
}

export function DateSelectionModal({
    opened,
    onClose,
    onSubmit,
}: DateSelectionModalProps) {
    const [selectedDate, setSelectedDate] = React.useState<Date | null>(null);

    useEffect(() => {
        if (!opened) {
            setSelectedDate(null);
        }
    }, [opened]);

    const handleSubmit = () => {
        if (selectedDate) {
            onSubmit(selectedDate);
            onClose();
        }
    };

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Select Sales Data Date"
            size="sm"
        >
            <Text size="sm" mb="md" color="dimmed">
                Please select the date for which this sales data applies:
            </Text>
            <Flex align="center" justify="center">
                <DatePicker
                    value={
                        selectedDate
                            ? selectedDate.toISOString().slice(0, 10)
                            : null
                    }
                    onChange={val =>
                        setSelectedDate(val ? new Date(val) : null)
                    }
                    maxDate={new Date()}
                    mb="xl"
                />
            </Flex>
            <Flex gap="md">
                <Button variant="outline" onClick={onClose} size="md">
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    disabled={!selectedDate}
                    size="md"
                >
                    Upload
                </Button>
            </Flex>
        </Modal>
    );
}
